module.exports = __webpack_public_path__ + "img/img-playtech.b5da7604.png";